import Modal from '@components/global/Modal';
import { useUI } from '@context/GlobalUIContext';
import DeliveryMethodModalContent from './DeliveryMethodModalContent';

import styles from './DeliveryMethodModal.module.scss';

const DeliveryMethodModal = () => {
  const { displayDeliveryMethodModal, closeDeliveryMethodModal } = useUI();

  const onCloseModal = () => {
    closeDeliveryMethodModal();
  };

  return (
    <Modal
      labelledBy="delivery-method-modal-heading"
      onClose={onCloseModal}
      isOpen={displayDeliveryMethodModal}
      classNames={styles.modal}
    >
      <DeliveryMethodModalContent onCloseModal={onCloseModal} />
    </Modal>
  );
};

export default DeliveryMethodModal;
